import { useModalStack } from "../utils/modalContext";
import { useEffect } from "react";
import ItemModal from "./itemComponents/itemModal";

export function ModalRenderer() {
  const { modalStack, popModal, topModalId } = useModalStack();

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape" && modalStack.length > 0) {
        popModal();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [modalStack, popModal]);

  return (
    <>
      {modalStack.map((modal, index) => {
        const isTop = modal.id === topModalId;

        switch (modal.type) {
          case "itemModal":
            return (
              <ItemModal
                key={modal.id}
                {...modal.props}
                isTopModal={isTop}
                onClose={() => popModal()}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
}
